import { catchError, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject, Observable, empty as observableEmpty } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';

import { ApiResponseSystemMessage } from '../../interfaces/api-response-system-message.interface';
import { SecurityService } from '../../services/security/security.service';
import { ICON_TYPES, SYSTEM_MESSAGE_CARD_CLASSNAMES, SYSTEM_MESSAGE_TITLE_CODES } from '../../classes/common-values';

@Injectable()
export class SystemMessagesService implements OnDestroy {
  data$ = new BehaviorSubject(<ApiResponseSystemMessage[]>[]);
  unsubscribe$ = new Subject();

  constructor(private http: HttpClient, private securityService: SecurityService) { }

  ngOnDestroy() {
    this.unsubscribe();
  }

  unsubscribe() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  getData(): void {
    this.http
      .get('/api/tsorder/system-message')
      .pipe(
        takeUntil(this.unsubscribe$),
        catchError(error => this.securityService.ignoreError(error))
      )
      .subscribe((data: ApiResponseSystemMessage[]) => {
        const transformed = this.transformSystemMessages(data);
        this.data$.next(transformed);
      });
  }

  setData(data: ApiResponseSystemMessage[]) {
    const transformed = this.transformSystemMessages(data);
    this.data$.next(transformed);
  }


  transformSystemMessages(messages: ApiResponseSystemMessage[]): ApiResponseSystemMessage[] {
    if (!messages || messages.length === 0) {
      return [];
    }

    return messages.map(message => {
      const isError = message.titleCode === SYSTEM_MESSAGE_TITLE_CODES.ALERT || message.titleCode === SYSTEM_MESSAGE_TITLE_CODES.SYSTEM_UNAVAILABLE;
      return {
        ...message,
        icon: isError ? ICON_TYPES.WARNING : ICON_TYPES.INFO,
        className: isError ? SYSTEM_MESSAGE_CARD_CLASSNAMES.ERROR : SYSTEM_MESSAGE_CARD_CLASSNAMES.INFO
      };
    });
  }

}
